import React, { useState, useEffect } from "react";
import Environment from "~/common/Environment";
import { Video } from "~/common/Store/models/Video";
interface Props {
  videos: Video[];
  itemNumber: string;
}
function addUTCOffset(date?: string) {
  if (!date) {
    return "";
  }
  return `${date}-05:00`;
}
const VideosSchema = ({
  videos,
  itemNumber
}: Props) => {
  const [domain, setDomain] = useState("");
  const [imageDomain, setImageDomain] = useState("");
  useEffect(() => {
    setDomain(`https://www.${Environment.domainWithEnvironment}`);
    setImageDomain(Environment.subdomain ? `https://www.${Environment.domainWithEnvironment}` : `https://cdnimg.webstaurantstore.com`);
  }, []);
  const schemas = videos.map(video => {
    let videoDescription = "";
    if (video.isModelingVideo) {
      videoDescription = `This ${video.title} video is for ${itemNumber} product demonstration purposes only`;
    }
    if (video.description) {
      videoDescription = video.description;
    }
    return {
      "@context": "https://schema.org",
      "@type": "VideoObject",
      thumbnailUrl: `${imageDomain}${video.thumbnailImage}`,
      embedUrl: `${domain}/v/?num=${video.id}`,
      uploadDate: addUTCOffset(video.dateAdded),
      name: video.title,
      description: videoDescription
    };
  });
  return <>
      {schemas.map(x => <script key={x.name} type="application/ld+json" dangerouslySetInnerHTML={{
      __html: JSON.stringify(x)
    }} />)}
    </>;
};
export default VideosSchema;